import { DIValidators, F360Product, IF360Sidebar } from "@/core/@types/types";
import LogoIconGreen from "@/assets/f360-icon-green.png";
import F360Sidebar from "@/core/common/F360AbstractSidebar";
import { ContabilDashboardRouter } from "@/router/contabil/dashboard/types";
import { type IF360Validator } from "@/core/validators/F360Validator";
import { inject, injectable } from "inversify";
import LogoIconGray from "@/assets/f360-cinza.png";
import { ContabilPortalComunicaoRouter } from "@/router/contabil/comunicacao";
import { DiagnosticoPages } from "@/router/contabil/diagnostico/types";

import "reflect-metadata";

@injectable()
export default class F360ContabilSidebarConfig extends F360Sidebar {
  @inject(DIValidators.ACESSO_CONTABIL)
  private acessoContabilValidator!: IF360Validator;

  private temAcessoAoContabil() {
    return this.acessoContabilValidator.handleValidation();
  }

  handleSidebar(): Array<IF360Sidebar> {
    return [
      {
        menuLabel: "Contábil",
        img: LogoIconGreen,
        isGrouped: true,
        validator: [
          !this.temAcessoAoContabil(),
          !this.isCadis(),
          !this.isCielo(),
          !this.isSysAdmin()
        ],
        children: [
          {
            menuLabel: "Conheça o F360 Contábil",
            isItem: true,
            img: LogoIconGray,
            routerConfig: {
              product: F360Product.Contabil,
              routeName: ContabilDashboardRouter.Contratar
            }
          }
        ]
      },
      {
        menuLabel: "Contábil",
        img: LogoIconGreen,
        routerConfig: {
          product: F360Product.Contabil
        },
        validator: [
          this.temAcessoAoContabil(),
          !this.isCadis(),
          !this.isCielo(),
          !this.isSysAdmin()
        ],
        children: [
          {
            menuLabel: "Minhas Empresas",
            icon: "corporate_fare",
            routerConfig: {
              product: F360Product.Contabil,
              routeName: DiagnosticoPages.empresas
            }
          },
          {
            menuLabel: "Visão Geral",
            icon: "cardiology",
            routerConfig: {
              product: F360Product.Contabil,
              routeName: ContabilDashboardRouter.Index
            }
          },
          {
            menuLabel: "Visão Estratégica",
            icon: "monitor_heart",
            routerConfig: {
              product: F360Product.Contabil,
              routeName: ContabilDashboardRouter.Tributos
            }
          },
          {
            menuLabel: "Portal de Comunicação",
            icon: "captive_portal",
            routerConfig: {
              product: F360Product.Contabil,
              routeName: ContabilPortalComunicaoRouter.base
            }
          },
          {
            menuLabel: "Canal do Contador",
            icon: "person",
            routerConfig: {
              product: F360Product.Financas,
              routeName: this.handleFinancasURL("CanalContador")
            }
          }
        ]
      }
    ];
  }
}
